module.exports = __webpack_public_path__ + "static/image/help-center-platform-intro.svg?320cba727f93d6f488abef33c5f2adfa";